import React from "react";
import { Route, Routes } from "react-router-dom";
import { LoaderProvider } from "./context/LoaderContext";
import Home from "./pages/Home";
import Loader from "./components/Loader";
import PrivacyPolicy from "./pages/Policy";
import TermsConditions from "./pages/Terms";

function App() {
  return (
    <LoaderProvider>
      <div className="App">
        <Loader />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsConditions />} />
        </Routes>
      </div>
    </LoaderProvider>
  );
}

export default App;
